import React, { useEffect } from 'react';
import { Box, Grid, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import Logs from 'components/Logs';
import Layout from 'components/Layout';
import useStyles from './PartnerDetails.styled';
import { useParams } from 'react-router-dom';
import { OrganizationDetails } from 'components/Organization';
import { useDispatch, useSelector } from 'react-redux';
import { partnersActions } from 'state/modules/partners';

const PartnerDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const organization = useSelector((state) => state.partners.partner);

  useEffect(() => {
    if (id) {
      dispatch(partnersActions.fetchPartnersById(id));
    }
  }, [id, dispatch]);

  return (
    <Layout title={i18n.t('partners.title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t('partners.details_title', { id })}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <OrganizationDetails organization={organization} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Logs
                      title={i18n.t('partners.logs')}
                      targetType={'OrgToOrgAccess'}
                      organizationId={organization?.id}
                      height={400}
                      shared
                      secondary
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export { PartnerDetails };
